'use client'

import classNames from 'classnames'
import { includes } from 'lodash-es'
import { useSearchParams } from 'next/navigation'
import { useEffect, useMemo, useState } from 'react'
import Sticky from 'react-stickynode'
import { useBoolean, useLocation } from 'react-use'
import { slugToQuery } from '../utils'
import { HouseSearchContext, useHouseSearchState } from './context'
import SearchFilter from './filter'
import SearchInput from './input'
import SaveSearch from './saveSearch'

export default function SearchBarConent({
  state,
  suburbs,
  filterMeta
}) {

  const { showMap } = state
  const searchListState = useHouseSearchState(state)
  const routeParams = useMemo(() => slugToQuery(state).toString(), [state])

  const [fixed, setFixed] = useState(false)
  function stateChangeHandle({ status }) {
    setFixed(status === Sticky.STATUS_FIXED)
  }

  const location = useLocation()
  const searchParams = useSearchParams()
  const [isMapArea, toggleIsMapArea] = useBoolean(searchParams.has('center'))
  useEffect(() => {
    toggleIsMapArea(includes(window.location.search, 'center='))
  }, [location, toggleIsMapArea])

  const houseSearchState = useMemo(() => ({
    ...searchListState,
    state,
    suburbs,
    filterMeta,
    isMapArea,
    toggleIsMapArea,
    routeParams
  }), [searchListState, state, suburbs, filterMeta, isMapArea, toggleIsMapArea, routeParams])

  return (
    <HouseSearchContext.Provider value={houseSearchState}>
      <Sticky
        innerClass={classNames('bg-white !transform-none', { 'border-b !z-[110] border-b-2 border-b-orange': fixed, '!static': !fixed })}
        innerZ={50}
        onStateChange={stateChangeHandle}
      >
        <div className={classNames(
          'grid grid-cols-1 xl:grid-cols-[minmax(20%,30%),1fr] gap-y-10 gap-x-8 xl:gap-x-15 p1430:grid-cols-[minmax(20%,36%),minmax(20%,64%)]',
          { 'py-10': fixed, 'page-wrap': !showMap }
        )} id='search-bar'>
          <div className='min-w-0 flex gap-x-8 xl:gap-x-15'>
            <SearchInput className='flex-1'></SearchInput>
            <SaveSearch
              state={state}
              suburbs={suburbs}
              className='sm:px-16 lg:hidden'
            />
          </div>
          <div className='min-w-0 flex gap-x-8 xl:gap-x-15'>
            <SearchFilter wrapClassName='flex-1' />
            <SaveSearch
              state={state}
              suburbs={suburbs}
              className='hidden lg:flex'
            />
          </div>
        </div>
      </Sticky>
    </HouseSearchContext.Provider>
  )
}